"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getField = void 0;
function getField(subject, key, defaultValue) {
    return (subject && subject[key]) || defaultValue;
}
exports.getField = getField;
//# sourceMappingURL=getField.js.map